<template>
  <SogPage
    id="page"
    :title="_title"
  >
    <SogCard>
      <SogCardTitle>Wählen Sie ein Datei aus</SogCardTitle>
      <SogCardContent>
        <SogUploader
          ref="_uploader"
          v-model="_array"
          :multiple="false"
        />
      </SogCardContent>
      <SogCardActions>
        <SogCardActionButton
          v-show="_array.length>0"
          mdi-icon="mdi-upload"
          @click="onImport"
        >
          importieren
        </SogCardActionButton>
      </SogCardActions>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, ref} from "vue";
import {onBeforeRouteUpdate, useRouter,} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogUploader from "@/shared/ui/SogUploader.vue";
import apiUsNato from "@/modules/UsNato/api";
import {TempFileInfo} from "@/shared/model/TempFileInfo";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import PersonIds from "@/shared/model/PersonIds";
import {useAccountStore} from "@/stores/accountStore";
import notificationService from "@/shared/services/NotificationService";


const _uploader = ref<InstanceType<typeof SogUploader> | null>(null)

const _title = ref("Bordereau hochladen")
const _spinner = useSpinner()
const _api = apiUsNato
const _array = ref<TempFileInfo[]>([])
const _accountStore = useAccountStore()
const _router = useRouter()


async function p_init() {
  _spinner.show()
  try {
    if (_accountStore.person && _accountStore.person.id !== PersonIds.UsNato && !_accountStore.isRoot) {
      _router.back()
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


async function onImport() {
  if (_array.value.length !== 1)
    return;
  const res = await _api.upload(_array.value[0].fileName);
  if (res) {
    notificationService.success("Datei " + _array.value[0].fileName + " wurde hochgeladen")
    _uploader.value?.clear()
    _spinner.hide()
  }
}


</script>
<style scoped>
</style>
